<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Identification and others
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      ValidationObserver(ref="Validation" slim)
        .row
          .col-md-6
            .row
              .col-12
                h4.mb-3 IDENTIFICATION
              .col-12
                ValidationProvider(name="tax identification number" rules="required" v-slot="{errors}" slim)
                  .form-group
                    label(for="taxIdentificationNumber") Tax Identification Number
                    input.form-control#taxIdentificationNumber(:class="{'border-danger': errors.length > 0}" type="text" name="taxIdentificationNumber" v-model="form.taxIdentificationNumber")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="social security number" rules="required" v-slot="{errors}" slim)
                  .form-group
                    label(for="socialSecurityNumber") Social Security System #
                    input.form-control#socialSecurityNumber(:class="{'border-danger': errors.length > 0}" type="text" name="socialSecurityNumber" v-model="form.socialSecurityNumber")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="HDMF" rules="required" v-slot="{errors}" slim)
                  .form-group
                    label(for="HDMF") Home Development Mutual Fund (HDMF) #
                    input.form-control#HDMF(:class="{'border-danger': errors.length > 0}" type="text" name="HDMF" v-model="form.HDMF")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="PHIC" rules="required" v-slot="{errors}" slim)
                  .form-group
                    label(for="PHIC") Philippine Health Insurance Corporation (PHIC) #
                    input.form-control#PHIC(:class="{'border-danger': errors.length > 0}" type="text" name="PHIC" v-model="form.PHIC")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
          .col-md-6
            .row
              .col-12
                h4.mb-3 CONTACT DATA
              .col-12
                ValidationProvider(name="cellphone number globe" rules="" v-slot="{errors}" slim)
                  .form-group
                    label(for="cellNumGlobe") Cellphone Number (Globe)
                    input.form-control#cellNumGlobe(:class="{'border-danger': errors.length > 0}" type="text" name="cellNumGlobe" v-model="form.cellNumGlobe")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="cellphone number smart" rules="" v-slot="{errors}" slim)
                  .form-group
                    label(for="cellNumSmart") Cellphone Number (Smart)
                    input.form-control#cellNumSmart(:class="{'border-danger': errors.length > 0}" type="text" name="cellNumSmart" v-model="form.cellNumSmart")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="telephone number" rules="" v-slot="{errors}" slim)
                  .form-group
                    label(for="telephoneNumber") Telephone Number
                    input.form-control#telephoneNumber(:class="{'border-danger': errors.length > 0}" type="text" name="telephoneNumber" v-model="form.telephoneNumber")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
                ValidationProvider(name="email address" rules="required" v-slot="{errors}" slim)
                  .form-group
                    label(for="emailAddress") Email Address
                    input.form-control#emailAddress(:class="{'border-danger': errors.length > 0}" type="text" name="emailAddress" v-model="form.emailAddress")
                    small.text-danger(v-if="errors.length") {{ errors[0] }}.
</template>

<style scoped=""></style>

<script>
  import { ref, reactive, watch, computed } from '@vue/composition-api'
  
  export default {
    name: 'step_4',
    props: {
      value: {
        type: Object,
        require: true
      }
    },
    emits: ['prev', 'next'],

    setup(props, {emit}) {
      const form = reactive(props.value)
      const beneficiaryIsSubmitted = ref(false)
      // const beneficiaryForm = reactive({
      //   benificiaryName: '',
      //   benificiaryRelationship: '',
      //   benificiaryDateOfBirth: '',
      // })

      const Validation = ref(null)
      // const BeneficiaryFormValidation = ref(null)

      

      const prev = () => {
        emit('prev');
      }
      const next = () => {
        emit('next');
      }
      const validate = () => {
        emit('input', form)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      // const isBeneficiaryFormRequired = computed(() => {
      //   return state.value.matches('beneficiary') || !!beneficiaryForm.benificiaryName || !!beneficiaryForm.benificiaryRelationship || !!beneficiaryForm.benificiaryDateOfBirth
      // })
      
      return {
        // send, state,
        form,
        // isBeneficiaryFormRequired,
        Validation, prev, next, validate
      }
    }
  }
</script>